<template>
	<div class="wrapper" :style="{ height: select ? 'auto' : '100%' }">
		<top-info :loanInfo="loan_info"></top-info>
		<div class="middle">
			<div class="time">
				<span>
					El préstamo caducará al final de la cuenta regresiva
					{{ countdown.hour }}:{{ countdown.minute }}:{{ countdown.second }}
				</span>
			</div>
			<div class="main">
				<div class="center">
					<div class="title">Monto depositado ($)</div>
					<div class="number">
						{{ addComma(calculateData.borrowAmount) }}
					</div>
				</div>
				<div class="center">
					<div class="title">Plazo (días)</div>
					<div class="number">
						{{ addComma(calculateData.period) }}
					</div>
				</div>
			</div>
			<com-coupon :couponData="couponData" @confirmarEmit="confirmarEmit"></com-coupon>
			<div class="bottom">
				<div class="bottom_main">
					<span>Fecha de pago</span>
					<span>{{ calculateData.firstRepayDateFormat }}</span>
				</div>
				<div class="bottom_main" @click="handleSelect">
					<span>Pago total</span>
					<div>
						<span
							:style="
								calculateData.totalRepayAmountOld != calculateData.totalRepayAmount
									? 'text-decoration:line-through'
									: ''
							"
						>
							$ {{ addComma(calculateData.totalRepayAmountOld) }}
						</span>
						<span v-if="calculateData.totalRepayAmountOld != calculateData.totalRepayAmount">
							&nbsp;$ {{ addComma(calculateData.totalRepayAmount) }}
						</span>
					</div>
				</div>
				<div class="bottom_main" @click="handleSelect">
					<span>Detalles de intereses</span>
					<div class="flex">
						<img src="@/assets/image/internal/initialconfirm/bottom.png" alt="" v-if="select == false" />
						<img src="@/assets/image/internal/initialconfirm/top.png" alt="" v-else />
					</div>
				</div>
			</div>
			<div class="bottom fee_select" v-show="select">
				<div class="bottom_main">
					<span>Monto depositado</span>
					<span class="money">
						<span
							:style="
								calculateData.borrowAmountOld != calculateData.borrowAmount
									? 'color:#3A3A3A; text-decoration: line-through;'
									: ''
							"
						>
							$ {{ addComma(calculateData.borrowAmountOld) }}
						</span>
						<span v-if="calculateData.borrowAmountOld != calculateData.borrowAmount">
							&nbsp;$ {{ addComma(calculateData.borrowAmount) }}
						</span>
					</span>
				</div>
				<div class="bottom_main" style="padding-top: 0.3rem;">
					<span>Tarifa de servicio Cloud</span>
					<div>
						<span style="text-decoration: line-through;"> $ {{ addComma(calculateData.fixedDiscount) }} </span>
						<span>&nbsp;$ {{ addComma(calculateData.totalServiceFee) }}</span>
					</div>
				</div>
				<!-- <div class="bottom_main">
          <span>IVA</span>
          <span>$ {{ addComma(calculateData.totalGst) }}</span> 
        </div> -->
				<div class="bottom_main">
					<span>Interés@25% e.a</span>
					<span>$ {{ addComma(calculateData.totalInterest) }}</span>
				</div>
			</div>
			<swipe-info :bannerList="bannerList" style="margin-top:.2rem"></swipe-info>
			<div class="prestano">
				<img v-if="prestamoCheck" src="@/assets/image/internal/select.webp" alt="" @click="handlePrestamo" />
				<img v-else src="@/assets/image/internal/select_no.webp" alt="" @click="handlePrestamo" />
				<span>He leído y acepto el&nbsp;</span>
				<span style="text-decoration: underline;" @click="gotoLoanAgree">
					contrato de préstamo.
				</span>
			</div>
			<div class="button" @click="handleConfirm">MODIFICAR</div>
		</div>
		<!-- Pop up when countdown is 0 -->
		<van-dialog v-model="failureShow" :show-confirm-button="false" class="dialog">
			<div class="info">
				Lamentamos que su pedido ya esté vencido. ¡Vuelva a solicitar y obtendrá más beneficios!
			</div>
			<button @click="handleFailureConfirmar">CONFIRMAR</button>
		</van-dialog>
	</div>
</template>
<script>
	import common from '@/mixins/common.js'
	import comCoupon from '@/components/internal/coupon.vue'
	import topInfo from '@/components/internal/topInfo.vue'
	import { addComma } from '@/utils/internal'
	import swipeInfo from '@/components/internal/swipeInfo.vue'
	export default {
		mixins: [common],
		components: {
			comCoupon,
			topInfo,
			swipeInfo,
		},
		data() {
			return {
				select: false,
				calculateData: {},
				checked: true,
				time: null,
				couponData: {},
				accountCouponId: '',
				couponType: null,
				couponAmount: null,
				changed: false,
				prestamoCheck: false,
				bannerList: [],
				loan_info: {},
				countdown: {
					hour: '',
					minute: '',
					second: '',
				},
				failureShow: false,
				selectedRadio: '',
				confirmarObjectValue: {},
			}
		},
		created() {
			this.getApiHead()
			this.getAccessToken()
			this.refreshPage()
			window.refreshPage = this.refreshPage
		},
		methods: {
			addComma,
			refreshPage() {
				this.getCalculate()
				this.getLoanInfo('hsm')
				this.getGetBanner({ bannerType: 5 })
			},
			//获取确认后的优惠券数据
			confirmarEmit(value) {
				this.confirmarObjectValue = value
			},
			gotoLoanAgree() {
				window.android.gotoLoanAgree()
			},
			//Trial
			getCalculate(radio) {
				this.$axios
					.post(this.apiHeadGatewayVh + 'calculate', {
						...this.params,
						accountCouponId: radio ? radio : -1,
					})
					.then((res) => {
						if (res.data.code == 0) {
							if (JSON.parse(res.data.data).code == 'SUCCESS') {
								this.calculateData = JSON.parse(res.data.data).data
								console.log('this.calculateData', this.calculateData)
								this.getCoupon({ coupon_type: 5 }) //Withdrawal+Deduction
							} else {
								this.$toast(JSON.parse(res.data.data).codeDesc)
							}
						}
					})
			},

			countTime(value) {
				clearTimeout(this.time)
				let millisUntilFinished = value - 1000
				let day = parseInt(millisUntilFinished / (1000 * 60 * 60 * 24)) /*单位天*/

				let hour = parseInt((millisUntilFinished - day * (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) /*单位时*/

				let minute = parseInt(
					(millisUntilFinished - day * (1000 * 60 * 60 * 24) - hour * (1000 * 60 * 60)) / (1000 * 60),
				) /*单位分*/

				let second = parseInt(
					(millisUntilFinished - day * (1000 * 60 * 60 * 24) - hour * (1000 * 60 * 60) - minute * (1000 * 60)) / 1000,
				) /*单位秒*/

				if (day * 24 + hour >= 10) {
					this.countdown.hour = day * 24 + hour + ''
				} else {
					this.countdown.hour = '0' + hour
				}
				if (minute >= 10) {
					this.countdown.minute = minute + ''
				} else {
					this.countdown.minute = '0' + minute
				}
				if (second >= 10) {
					this.countdown.second = second + ''
				} else {
					this.countdown.second = '0' + second
				}
				if (this.countdown.hour == 0 && this.countdown.minute == 0 && this.countdown.second == 0) {
					clearTimeout(this.time)
					this.getUpdateInvalid()
					return
				}
				this.time = setTimeout(() => {
					this.countTime(millisUntilFinished)
				}, 1000)
			},
			handleSelect() {
				this.select = !this.select
			},
			//Do you want to check the agreement
			handlePrestamo() {
				this.prestamoCheck = !this.prestamoCheck
			},

			//Order Expiration
			getUpdateInvalid() {
				this.$axios
					.post(this.apiHeadGatewayVh + 'order/update/invalid', {
						...this.params,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.failureShow = true
						}
					})
			},
			//Countdown to 0, click on pop-up to refresh page
			handleFailureConfirmar() {
				this.refreshPage()
				this.failureShow = false
			},
			//Confirm withdrawal
			handleConfirm() {
				window.android.loanConfirm(
					this.loan_info.loan_amount ? this.loan_info.loan_amount?.toString() : '0',
					this.loan_info.total_amount_due ? this.loan_info.total_amount_due?.toString() : '0',
					this.loan_info.loan_term ? this.loan_info.loan_term?.toString() : '0',
					this.confirmarObjectValue.confirmarId ? this.confirmarObjectValue.confirmarId?.toString() : '0',
				)
			},
		},
		beforeRouteLeave(to, from, next) {
			// 清除 sessionStorage 缓存
			sessionStorage.clear()
			// 继续导航到下一个路由
			next()
		},
	}
</script>
<style lang="scss" scoped>
	@import '@/assets/style/internal/initialconfirm/index.scss';
	@import '@/assets/style/internal/toast.scss';
</style>
